import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadniDani } from './radni-dani/radni-dani';

@NgModule({
  imports: [
    CommonModule
  ]
  , declarations: [
  ]
  , exports:[
  ]
})
export class KadBlModule { }
